import { OrgType } from 'src/@types/org';

export const formatOrgSubheader = (org: OrgType) => {
  switch (org.race_typeRace) {
    case 'national':
      return 'Nationwide';
    case 'national-multi-state':
      return 'Multi-State';
    case 'governor':
      return org.selected_state + ' Governor';
    case 'us-senate':
      return org.selected_state + ' - US Senate';
    case 'us-congress':
      return org.selected_state + ' CD-' + org.selected_congressional_district;
    case 'other-statewide':
      return org.selected_state + ' Statewide';
    case 'state-senate':
      return org.selected_state + ' SD-' + org.selected_senate_district;
    case 'state-house':
      return org.selected_state + ' HD-' + org.selected_house_district;
    case 'mayor':
      return org.selected_state + ' - ' + org.selected_city + ' Mayor';
    case 'other-local':
      return org.selected_state + ' - ' + org.selected_city + ' Local';
    case 'city':
      return org.selected_state + ' - ' + org.selected_city + ' Local';
    case 'county':
      return org.selected_state + ' - ' + org.selected_county + ' County';
    case 'jurisdiction':
      return org.selected_state + ' - ' + org.selected_jurisdiction;
    default:
      return '';
  }
};
